import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./10_SignIn.css";
import PageWrapper from "../00_common/PageWrapper";
import SignUp from "./20_SignUp";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../../store/slices/userInfoSlice";
import EasyDialog from "../00_common/EasyDialog";

function SignIn() {
  const navigate = useNavigate();
  const [showSignDialog, setShowSignDialog] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("1", event.target[0].value);
    // console.log("2", event.target[1].value);
    // console.log("3", event.target.elements.email.value);
    // console.log("4", event.target.password.value);
    let email = event.target.email.value || "";
    // if (email.includes("customer")) navigate("/customer");
    // else if (email.includes("agency")) navigate("/agency");
    // else if (email.includes("supplier")) navigate("/supplier");
    // else if (email.includes("admin") || email.includes("master"))
    //   navigate("/admin");
    // else return;
    // window.location.reload(true);
    if (email.includes("customer")) {
      dispatch(
        setUserInfo({
          id: "4e043b70-c9e9-49b1-9fe7-994675e927db",
          org_no: null,
          role: { name: "customer" },
        })
      );
      window.location = "/customer";
    } else if (email.includes("agency")) {
      dispatch(
        setUserInfo({
          id: "593cfd6a-3956-48af-a5c2-3a86e83ce8cf",
          org_no: "659c833f-07e5-483f-8c24-f0b174ac05bf",
          role: { name: "agency" },
        })
      );
      window.location = "/agency";
    } else if (email.includes("furniture")) {
      dispatch(
        setUserInfo({
          id: "0d2a6a86-8ce2-48cf-a522-be67b2a4eaea",
          org_no: {
            org_no: "ee2e4677-3731-45eb-a23d-8a7197b1d1b7",
            org_nm: "BIZ NỘI THẤT",
            org_rep_img: "9e967bd2-e808-4409-88f4-a04d87918f2b",
          },
          role: { name: "supplier" },
        })
      );
      window.location = "/supplier";
    } else if (email.includes("appliance")) {
      dispatch(
        setUserInfo({
          id: "dad39b86-494e-4670-995f-8b7b13c1a5e7",
          org_no: {
            org_no: "b13cc5fe-30dd-48a9-8c1d-58779d198012",
            org_nm: "Lazada",
            org_rep_img: "50da38bf-34d7-450b-93ed-cdfff8b0b706",
          },
          role: { name: "supplier" },
        })
      );
      window.location = "/supplier";
    } else if (email.includes("admin") || email.includes("master")) {
      dispatch(
        setUserInfo({
          id: "d94f0ac0-5082-450a-9e8f-6d27aa9b69f2",
          org_no: "e4681133-1a6e-4409-bd72-ceb2d9bf214e",
          role: { name: "master" },
        })
      );
      window.location = "/admin";
    } else return;
  };

  const [dialogConfig, setDialogConfig] = useState();
  const resetDemoData = () => {
    localStorage.clear();
    setDialogConfig({
      message: "All work data has been reset.",
      yesButtonName: "OK", //default Ok
      yesButtonClass: "type-manager",
      /* type-manager,type-user,type-negative,type-warning,*/
    });
  };

  return (
    <>
      <PageWrapper type="container">
        <div className="cp-sign-in">
          <div className="panel left">
            <div className="sign-container">
              <div className="icon-block" onClick={resetDemoData}>
                <div className="icon-wrap">
                  <i className="fa-solid fa-key" />
                </div>
              </div>
              <div className="greeting">
                <p>Hi There!</p>
                <span>
                  Sign in to manage your properties and interiors on My Viethome
                </span>
              </div>
              <form className="form-wrap" onSubmit={handleSubmit}>
                <div className="input-wrap">
                  <label htmlFor="user-email">Email address</label>
                  <input
                    type="text"
                    id="user-email"
                    name="email"
                    placeholder="Email"
                    defaultValue=""
                    list="input-list"
                  />
                  <datalist id="input-list">
                    <option value="nguyen@customer.com" />
                    <option value="furniture@supplier.com" />
                    <option value="appliance@supplier.com" />
                    <option value="agency@agency.com" />
                    <option value="master@admin.com" />
                  </datalist>
                </div>
                <div className="input-wrap">
                  <label htmlFor="user-password">Password</label>
                  <input
                    type="password"
                    id="user-password"
                    name="password"
                    placeholder="Password"
                    defaultValue=""
                  />
                </div>
                <button className="btn btn-l type-manager round" type="submit">
                  Sign In
                </button>
              </form>
              <div
                className="sign-up-info"
                onClick={() => setShowSignDialog(true)}
              >
                Don’t have an account? <a>Sign up now</a>
              </div>
            </div>
          </div>
          <div className="panel right"></div>
        </div>
        {showSignDialog && <SignUp setShowSignDialog={setShowSignDialog} />}
      </PageWrapper>
      <EasyDialog
        dialogConfig={dialogConfig}
        setDialogConfig={setDialogConfig}
      />
    </>
  );
}

export default SignIn;
